import type { TaskPayload } from "resha"
import { CollaboratorStatus } from "./CollaboratorModel"

export enum TaskSortBy {
    id = "id",
    created = "created",
    status = "status",
    completed = "completed",
    title = "title",
    type = "type"
}

export enum TaskOrderBy {
    asc = "asc",
    desc = "desc"
}

export enum LabelerType {
    hero = "HERO",
    collaborator = "COLLABORATOR",
    ai = "AI"
}

export const TaskListQueryParams = {
    orderBy: TaskOrderBy.asc,
    sortBy: TaskSortBy.created
}

export enum TaskStatus {
    SCHEDULED = "SCHEDULED",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    CANCELED = "CANCELED"
}

export interface TaskModel {
    id: string
    created: string
    completed: string
    labelerType: LabelerType
    labelerStatus?: CollaboratorStatus
    status: TaskStatus
    title: string
    type: string
    /**
     * Labeler email
     */
    labeler?: string
    labelerUsername?: string
    /**
     * Crowd worker ID
     */
    labelerId?: number
    labelingTime?: number
    correct?: boolean
}

export interface APITaskDetailsModel extends TaskModel {
    actions: {}
    input: TaskPayload
    output: TaskPayload
    response?: TaskPayload
    schemaVersion: string
    taskInfo: {}
}

export interface APITaskModel {
    tasks: TaskModel[]
    total: number
    pageSize: number
    pageNumber: number
    pages: number
}

export interface UITaskModel extends TaskModel {
    taskNumber: number
}

export interface APITaskListParams {
    sortBy: TaskSortBy
    orderBy: TaskOrderBy
}

export function getTaskID(model: TaskModel): string {
    return model.id
}

export function encodeTaskAPIListParams(
    params: APITaskListParams
): URLSearchParams {
    const search = new URLSearchParams()

    search.set("orderBy", params.orderBy)
    search.set("sortBy", params.sortBy)

    return search
}
